


import twLogo1 from "../images/tw/logo1.png"
import twLogo2 from "../images/tw/logo2.png"
import twLogo3 from "../images/tw/logo3.png"
import twLogo5 from "../images/tw/logo5.png"
import twLogo6 from "../images/tw/logo6.png"
import twLogo7 from "../images/tw/logo7.png"
import twLogo8 from "../images/tw/logo8.png"
import twLogo9 from "../images/tw/logo9.png"
import twLogo10 from "../images/tw/logo10.png"
import twLogo11 from "../images/tw/logo11.png"
import twLogo12 from "../images/tw/logo12.png"

import { UserLogoMapMobileType } from 'globalCommon/utils/index'

export const UserLogoMap: UserLogoMapMobileType = {



    tw: [twLogo1, twLogo2, twLogo3, twLogo5, twLogo6, twLogo7, twLogo8, twLogo9, twLogo10, twLogo11, twLogo12],
};
